import React from 'react';
import IntegrationID from '@/constants/integrations/IntegrationID';
import useExternalIntegrations from '@/lib/hooks/swr/useExternalIntegrations';
import type { ExternalIntegration } from '@/types/Integration';

export default function useIWaveIntegration() {
  const { data } = useExternalIntegrations();
  const { externalIntegrations } = data || {};

  return React.useMemo(
    () =>
      externalIntegrations?.find(
        (externalIntegration: ExternalIntegration) =>
          externalIntegration.source === IntegrationID.IWAVE,
      ),
    [externalIntegrations],
  );
}
